import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M19.83 0H4.17A4.19 4.19 0 0 0 0 4.17v15.66A4.19 4.19 0 0 0 4.17 24h15.66A4.19 4.19 0 0 0 24 19.83V4.17A4.19 4.19 0 0 0 19.83 0m-1.48 12.21a.49.49 0 0 1-.45.29h-3.15a.25.25 0 0 0-.25.25V19a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-6.25a.25.25 0 0 0-.25-.25H6.1a.49.49 0 0 1-.45-.29.51.51 0 0 1 .08-.54l5.89-6.74a.51.51 0 0 1 .76 0l5.89 6.74a.51.51 0 0 1 .08.54"
    }, null, -1)
  ]));
}
const computerKeyboardShift = { render };
export {
  computerKeyboardShift as default,
  render
};
//# sourceMappingURL=computer-keyboard-shift.svg.js.map
